<template>
    <div class="main_center" >
        <div class="content common_header">
            <div class="search">
                业务类型：<el-select v-model="businessType" value-key="value" size="medium"
                           style="width:150px;display: inline-block;margin-right: 12px;" @change="seachBtn">
                    <el-option v-for="(item, index) in businessTypeNamelist" :key="index" :label="item.name"
                               :value="item.value"></el-option>
                </el-select>
                <el-input
                    style="width:500px;"
                    :placeholder="placeholderArea"
                    v-model="searchKey"
                    @keyup.enter.native="seachBtn"
                    clearable
                ></el-input>
                <el-button type="primary" size="small" class="rightSearchBtn" @click="seachBtn">搜索</el-button>
                <el-button type="text" @click="changeMoreSearch">
                    高级搜索
                    <span class="el-icon-arrow-down" v-if="!moreSearchItem"></span>
                    <span class="el-icon-arrow-up" v-else></span>
                </el-button>
            </div>
        </div>
        <headerVue style="margin-bottom:10px;background:#FFF;width:100%;" ref="headerVueRef" :showMore="moreSearchItem" @seachBtn="seachBtn"> </headerVue>
        <busWitnessTable :busWitnessTableType.sync="businessType" ref="busWitnessTableRef"  :advancedsearchvalue.sync="advancedsearchvalue" ></busWitnessTable>
    </div>
</template>

<script>
import { mapState } from "vuex";
import busWitnessTable from './busWitnessList';
import headerVue from "./components/header";
export default {
    components: {
      busWitnessTable,
      headerVue
    },
    data(){
        return{
            timer:false,
            user:'',
          businessType:"",
          searchKey:'',
          placeholderArea: "请输入项目名称/项目编号/招标人名称/中标人名称",
          moreSearchItem:false,
          advancedsearchvalue:{}, //高级搜索传来的值供分页使用
            businessTypeNamelist: [],
        }
    },
    activated(){

        this.businessType = this.$route.params.type?this.$route.params.type:"GC";
        window.sessionStorage.setItem("witnessHisBusinessType",this.businessType)

    },
    created(){
        this.getDic('jz_dgwitness_bustype');
        this.businessType = this.$route.params.type?this.$route.params.type:"GC";
        window.sessionStorage.setItem("witnessHisBusinessType",this.businessType)

    },
    mounted() {

    },
    computed: {
        ...mapState({
            stateData:state=>state.user
        })
    },

    methods:{
        getDic(type) { // 获取字典
            this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
                if (res.data.code === '1') {
                    switch (type) {
                        case 'jz_dgwitness_bustype': this.businessTypeNamelist = res.data.data; break;
                    }
                }
            })
        },
        seachBtn(val){
            // val=1 代表此时要清空重置筛选
         if(val==1){ this.searchKey=''}
         this.advancedsearchvalue = this.$refs.headerVueRef.form
         console.log(this.$refs.headerVueRef.form,'我看下this.$refs.headerVueRef.form');
         let filterObj=this.$refs.headerVueRef.form
         filterObj.searchKey=this.searchKey
         filterObj.busType=this.businessType
         this.$refs.busWitnessTableRef.getDataLists(filterObj)
        },
        changeMoreSearch(){
            this.moreSearchItem=!this.moreSearchItem
        },
    },
    filters:{

    },
    destroyed(){

    },
}
</script>
<style lang="less">
.common_header {
    .search {
        .el-input .el-input__inner,
        .el-input--medium .el-input__inner,
        .el-input--suffix .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        .rightSearchBtn {
            height: 32px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
</style>
<style lang="less" scoped>
@main-color: @--color-primary;
.common_header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    height: 80px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    > h2 {
        margin-bottom: 30px;
        font-weight: bold;
    }
    > .search {
        display: flex;
        justify-content: center;
        align-items: center;
        > .el-button--primary {
            background-color: @main-color;
            border-color: @main-color;
        }
    }
    > .my_nav {
        margin-top: 30px;
        > span {
            padding: 10px;
            cursor: pointer;
            position: relative;
            > i {
                font-style: normal;
                margin-left: 1px;
            }
            &:after {
                content: "";
                width: 0%;
                height: 2px;
                background: #1890ff;
                position: absolute;
                bottom: 0;
                left: 0;
                transition: all 0.7s;
            }
            &:hover {
                color: #1890ff;
            }
            &:hover:after {
                width: 100%;
            }
        }
        > .active {
            color: #1890ff;
            &:after {
                content: "";
                width: 100%;
                height: 2px;
                background: #1890ff;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
}
</style>
